import { Button } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import useTranslation from 'lib/hooks/useTranslation';

import AppErrorIcon from '../AppErrorIcon';
import AppErrorTitle from '../AppErrorTitle';

interface Props {
  hash?: string;
}

const AppErrorBlockConsensus = ({ hash }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <AppErrorIcon statusCode={ 404 }/>
      <AppErrorTitle title={ t('error_pages.block_lost_consensus') }/>
      <Button
        mt={ 8 }
        size="lg"
        variant="outline"
        as="a"
        href={ hash ? route({ pathname: '/block/[height_or_hash]', query: { height_or_hash: hash } }) : route({ pathname: '/' }) }
      >
        { hash ? t('error_pages.view_reorg') : t('error_pages.back_to_home') }
      </Button>
    </>
  );
};

export default AppErrorBlockConsensus;
